import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../common/mapper";

class MasterLogistikMotorVarianFilter extends Component {
    discontinueOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            dataVariant: [],
        };
    }

    componentDidMount() {
        this.fetchDataVariant();
    }

    handleSubmit = () => {
        this.props.onSubmit();
    };

    fetchDataVariant = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataVariant: response.data.data,
                }));
            } else {
                this.setState((prevState) => ({
                    ...prevState,
                    dataVariant: this.dummyDataVariant,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleDDL
                                id="select_options_filter_kode_varian"
                                box="search"
                                name="kodeVariant"
                                label="Kode Varian"
                                isClearable={true}
                                value={this.props.selectedData.kodeVariant}
                                options={this.state.dataVariant.map(
                                    item => mapToObjectDDL(
                                        item.kodeVariant,
                                        item.kodeVariant
                                    ))}
                                onChange={(value, {name}) =>
                                    this.props.onValueChange(name, value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_kode_unit_pabrik"
                                name="kodeUnitPabrik"
                                label="Kode Unit Pabrik"
                                value={this.props.selectedData.kodeUnitPabrik}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_nama_varian"
                                name="namaVariant"
                                label="Nama Varian"
                                value={this.props.selectedData.namaVariant}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_isi_silinder"
                                name="isiSilinder"
                                label="Isi Silinder"
                                box="onlyNumber"
                                value={this.props.selectedData.isiSilinder}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_digit_awal_nosin"
                                name="digitAwalNosin"
                                label="Digit Awal Nosin"
                                value={this.props.selectedData.digitAwalNosin}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_digit_awal_noka"
                                name="digitAwalNoka"
                                label="Digit Awal Noka"
                                value={this.props.selectedData.digitAwalNoka}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_filter_discontinue"
                                box="search"
                                name="discontinue"
                                label="Discontinue"
                                isClearable={true}
                                value={this.props.selectedData.discontinue}
                                options={this.discontinueOptions}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <FlexView hAlignContent="right">
                                <SimpleButton type="button" secondary onClick={() => this.props.onClearForm()}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterLogistikMotorVarianFilter;